// extracted by mini-css-extract-plugin
module.exports = {"txnButton":"StakingTxnButton_txnButton__2l7lM","activeButton":"StakingTxnButton_activeButton__2N_Ly","glowAnimation":"StakingTxnButton_glowAnimation__7JR1T"};